import { showError } from '../../../common/A1Alert/A1Alert';

export const SET_DATA = 'SET_DATA';
export const setData = (data) => ({
    type: SET_DATA,
    data,
});

export const SET_PLAYLIST = 'SET_PLAYLIST';
export const setPlaylist = (mixcloudDataPlaylist) => ({
    type: SET_PLAYLIST,
    mixcloudDataPlaylist,
});

export const RESET_DATA = 'RESET_DATA';
export const resetData = () => ({
    type: RESET_DATA,
});

export const SET_CURRENT_PODCAST_SLUG = 'SET_CURRENT_PODCAST_SLUG';
export const setCurrentSlug = (slug) => ({
    type: SET_CURRENT_PODCAST_SLUG,
    slug,
});

export const SET_ISLOADING = 'SET_ISLOADING';
const setIsLoading = (isLoading) => ({
    type: SET_ISLOADING,
    isLoading,
});

export const SET_NEXT_URL = 'SET_NEXT_URL';
const setNextUrl = (nextUrl) => ({
    type: SET_NEXT_URL,
    nextUrl,
});

export const NO_MORE_PODCAST = 'NO_MORE_PODCAST';
const setNoMorePodcast = (noMorePodcasts) => ({
    type: NO_MORE_PODCAST,
    noMorePodcasts,
});

export const SET_CURRENT_URL = 'SET_CURRENT_URL';
const setCurrentUrl = (url) => ({
    type: SET_CURRENT_URL,
    url,
});

export const SET_TEXT = 'SET_TEXT';
export const setNoticeText = (noticeText) => ({
    type: SET_TEXT,
    noticeText,
});

export const getDataPlaylistIfNeeded = () => (dispatch, getState) => {
    const { mixcloudDataPlaylist: currentDataPlaylist } = getState().podcasts.mixcloudPodcasts;

    // this function get playlist that exist on mixcloud
    if (currentDataPlaylist.length === 0) {
        const url = 'https://api.mixcloud.com/antena_1/playlists/';

        return fetch(url)
            .then((response) => response.json())
            .then((response) => dispatch(setPlaylist(response.data)))
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('error on fetch category', error);
            });
    }

    return Promise.resolve(1);
};

export const getDataIfNeeded = (slug) => (dispatch, getState) => {
    dispatch(setNoticeText(''));

    const qtd = 10; // qtd is quantity of data we get
    let url = 'https://api.mixcloud.com/antena_1/'; // ulr pattern for requests
    const dataSlug = getState().podcasts.mixcloudPodcasts.mixcloudDataPlaylist;
    let hasSlug = false;

    if (dataSlug.length > 0 && slug !== 'recentes') {
        dataSlug.forEach((item) => {
            if (item.slug === slug) {
                hasSlug = true;
            }
        });

        if (!hasSlug) {
            return dispatch(setNoticeText('Não há podcast relacionados com a categoria.'));
        }
    }

    const { currentPlaylistSlug } = getState().podcasts.mixcloudPodcasts;

    if (currentPlaylistSlug !== slug) { // do it verification between slugs
        dispatch(resetData());

        dispatch(setCurrentSlug(slug));

        dispatch(setCurrentUrl(false));

        dispatch(setNextUrl(false));

        dispatch(setNoMorePodcast(false));
    }

    const noMorePodcasts = getState().podcasts.mixcloudPodcasts.noMorePodcasts;

    if (noMorePodcasts) {
        // this verification return promise on case no more data
        dispatch(setNoticeText('- - -'));

        return Promise.resolve(1);
    }

    const currentUrl = getState().podcasts.mixcloudPodcasts.currentUrl;

    const nextUrl = getState().podcasts.mixcloudPodcasts.nextUrl;

    if (!currentUrl) { // here contruction the rest url depend on slug
        if (slug === 'recentes') {
            url += `cloudcasts/?limit=${qtd}`;
        } else {
            url += `playlists/${slug}/cloudcasts/?limit=${qtd}`;
        }

        // initial fetch
        dispatch(setNoMorePodcast(false));

        dispatch(setCurrentUrl(url));

        // eslint-disable-next-line no-use-before-define
        dispatch(funcFetch(url));
    } else if (nextUrl && currentUrl !== nextUrl) {
        // following fetchs
        dispatch(setCurrentUrl(nextUrl));

        // eslint-disable-next-line no-use-before-define
        dispatch(funcFetch(nextUrl));
    }

    return Promise.resolve(1);
};

const funcFetch = (url) => (dispatch) => {
    dispatch(setIsLoading(true));

    fetch(url)
        .then((response) => response.json())
        .then((response) => {
            dispatch(setIsLoading(false));

            if (response.data) {
                dispatch(setData(response.data));

                if (typeof response.paging !== 'undefined' && response.paging.next) {
                    dispatch(setNoticeText(''));

                    dispatch(setNextUrl(response.paging.next));
                } else {
                    dispatch(setNextUrl(false));

                    dispatch(setNoMorePodcast(true));

                    dispatch(setNoticeText('- - -'));// set trace if no more data
                }
            } else {
                throw 'No data in response';
            }
        })
        .catch((error) => {
            dispatch(setIsLoading(false));

            showError('Erro na comunicação com servidor. Tente de novo mais tarde.');

            // eslint-disable-next-line no-console
            console.log('error on fetch podcast', error);

            return dispatch(setNoticeText('Oops, ocorreu um erro na comunicação com servidor. Tente de novo mais tarde.'));
        });
};
